import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-cvx-header',
    imports: [CommonModule, MatButtonModule],
    templateUrl: './cvx-header.component.html',
    styleUrl: './cvx-header.component.scss'
})
export class CvxHeaderComponent {

    pTitle = input.required<string>();
    pFullName = input<string>('Unknow');
    pSRCImageProfileUser = input<string>('/images/no-avatar.png');
    pRoleName = input<string>('');
    btnToggle = output<void>();


    protected srcImageUser = computed(() => {
        if (this.pSRCImageProfileUser())
            return this.pSRCImageProfileUser();
        else
            return '/images/no-avatar.png';
    }); 

    protected shouldShowImage(): boolean {
        const name = this.pFullName().toLowerCase();

        const imgSrc = this.pSRCImageProfileUser();
        return !!(imgSrc && imgSrc !== '/images/no-avatar.png');
    }

    protected getUserInitials(): string {
        const name = this.pFullName();
        if (!name || name === 'Unknow') return 'U';
        
        const parts = name.trim().split(' ');
        if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }

    btnLeftMenuClick(event: Event) {
        this.btnToggle.emit();
    }
}
